export const getCookie = (cookieName) => {
  return window.document.cookie
    .split(';')
    .find((cookies) => cookies.includes(cookieName))
    ?.trim()
    .replace(`${cookieName}=`, '');
};
